/**
 * Matriz ACL: una fila por ruta, default deny.
 * Cada ruta lista todos los roles del catálogo en true.
 * Para restringir: borra la línea del rol o cambia a false.
 */

/**
 * @typedef {Object} RouteAccessRow
 * @property {string} path
 * @property {Record<string, boolean>} roles
 * @property {boolean} [matchPrefix]
 */

/** @type {RouteAccessRow[]} */
export const ROUTE_ACCESS_MATRIX = [

  // --- General ---
  {
    path: '/dashboard',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': false,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/profile',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/acceso-denegado',
    roles: {
      '__AUTHENTICATED__': true,
    },
  },

  // --- Producción ---
  {
    path: '/ordenes-fabricacion',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/programacion',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/oee-metricas',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/materiales-consumos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/lotes-trazabilidad',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/pda/sala-mezcla',
    roles: {
      'MANAG:Director': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },

  // --- Activos ---
  {
    path: '/jerarquia-activos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/lineas',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/products',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/asset-management',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/estados-disponibilidad',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },

  // --- Personas ---
  {
    path: '/empleados',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': false,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/calendario-labor',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': false,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/asistencia',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/asignaciones',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/asignacion-personal',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/salidas-especiales',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/control-horas',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/evaluaciones',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/gestion-empleados',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },

  // --- Procesos ---
  {
    path: '/datos-maestros-procesos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/parametros-procesos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/bom-rutas',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/instrucciones-trabajo',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/procesos-automaticos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/events',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': true,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/energy',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },

  // --- Calidad ---
  {
    path: '/planes-inspeccion',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/autocontrol-calidad',
    matchPrefix: true,
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/registros-autocontrol',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/caracteristicas-calidad',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/defectos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/control-estadistico',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/acciones-correctivas',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/certificados',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },

  // --- Seguridad y salud laboral ---
  {
    path: '/riesgos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/inspecciones-seguridad',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/accidentes',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/capacitaciones',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/epp',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },
  {
    path: '/salud-ocupacional',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
    },
  },

  // --- Configuración ---
  {
    path: '/config-empresa',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/config-plantas',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/config-calendario',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/config-turnos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/config-zonas-horarias',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/config-unidades',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/config-monedas',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/grafana-test',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/config-external',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },

  // --- Administración ---
  {
    path: '/seguridad',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/logs',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/usuarios',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/roles-permisos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  // --- Mantenimiento ---
  {
    path: '/planes-mantenimiento',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': false,
      'MAIN:Mechanic': false,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/planes-asignacion',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': false,
      'MAIN:Mechanic': false,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/planes-ejecucion',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': true,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/almacen-repuestos',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
  {
    path: '/kpi',
    roles: {
      'MANAG:Director': true,
      'MANAG:Assistant': true,
      'OPER:Manager': true,
      'OPER:Supervisor': true,
      'PROD:Manager': true,
      'PROD:Process Engineer': true,
      'PROD:Supervisor': true,
      'PROD:Operator': false,
      'PROD:Assistant': true,
      'MAIN:Manager': true,
      'MAIN:Supervisor': true,
      'MAIN:Technician': false,
      'MAIN:Electrician': true,
      'MAIN:Mechanic': true,
      'QUAL:Manager': true,
      'QUAL:Supervisor': true,
      'QUAL:Inspector': true,
      'QUAL:Technician': true,
      'LOG:Manager': true,
      'LOG:Supervisor': true,
      'LOG:Operator': true,
      'LOG:Assistant': true,
      'ENG:Manager': true,
      'ENG:Process Engineer': true,
      'ENG:Project Engineer': true,
      'ENG:Design Engineer': true,
      'ADM:Manager': true,
      'ADM:Supervisor': true,
      'ADM:Accountant': true,
      'ADM:Assistant': true,
      'HR:Manager': true,
      'HR:Assistant': true,
      'OT:Manager': true,
      'OT:System Administrator': true,
      'OT:Support Technician': true,
      '@group:authentik Admins': true,
    },
  },
];